module.exports = __webpack_public_path__ + "img/paypal.495664c2.png";